import React, {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './progress-badge.module.scss';
import {Invitation} from '../../types/invitation';
import {buildProgressSteps, summarize} from '../../utils/invitation-progress';

interface Props {
    invitation: Invitation;
    // id of the ReactTooltip rendered once by the page
    tooltipId: string;
}

// One-line "where is this invitation now" for the invitations table, same wording as the detail page
const ProgressBadgeComponent: FunctionComponent<Props> = ({invitation, tooltipId}: Props) => {
    const {t} = useTranslation();

    if (!invitation.progress) {
        return <span>{invitation.status}</span>;
    }

    const summary = summarize(buildProgressSteps(invitation, invitation.progress, t), t);
    return (
        <span className={`${styles.badge} ${styles[summary.state]} ${summary.stepKey === 'processed' ? styles.waitingForProcessing : ''} ${summary.waitingForClient ? styles.waitingForClient : ''}`}
              data-tip={`${summary.text ?? summary.headline} (${invitation.status})`}
              data-for={tooltipId}>
            <span className={styles.marker} aria-hidden="true"/>
            <span className={styles.label}>{summary.headline}</span>
        </span>
    );
};

export default ProgressBadgeComponent;
